import { Order } from '~/api-client/data-contracts'

type Included = {
  id: string
  type: string
  attributes: Record<string, any>
  relationships: Record<string, { data: { id: string; type: string } | { id: string; type: string }[] }>
}

export function findShippingStatus(order: Order, included: Included[]) {
  if (!order) return null
  if (order.attributes.capture !== 'completed') return null

  const orderItem = included.find((item) => item.type === 'order_item' && order.relationships.order_items.data.some((oi) => oi.id === item.id))
  if (!orderItem) return null

  return included.find((item) => {
    return item.type === 'shipping_status'
      && Array.isArray(orderItem.relationships.shipping_statuses.data)
      && orderItem.relationships.shipping_statuses.data.some((ss) => ss.id === item.id)
  })
}
